import { useMemo } from 'react';

import sortBy from 'lodash/sortBy';

import {
  KeyboardTabIcon,
  VisibilityIcon,
  VisibilityOffIcon,
} from '@gogame/ui/Icon';
import Stack from '@gogame/ui/Stack';

import {
  ActionButton,
  MarkerIcon,
  IconWrapper,
  Title,
  LegendItem,
  CrossedActionButton,
} from './components';

const LegendContent = ({
  payload,
  hiddenMetrics = [],
  ownAxisMetrics = [],
  onHover,
  onToggle,
  onChangeAxis,
  sort,
  withMoveToOwnAxis,
}) => {
  const sortedPayload = useMemo(() => {
    return sort ? sortBy(payload, [sort]) : payload;
  }, [sortBy, payload]);

  const yAxisGroupCounter = sortedPayload.reduce((m, { payload }) => {
    return {
      ...m,
      [payload.yAxisId]: (m[payload.yAxisId] || 0) + 1,
    };
  }, {});

  return (
    <div style={{ paddingTop: 8 }}>
      {sortedPayload.map(({ color, value, payload: legendPayload }, index) => {
        const id = legendPayload.id;
        const hidden = hiddenMetrics.includes(id);
        const ownAxis = ownAxisMetrics.includes(id);
        const { strokeOpacity } = legendPayload;

        return (
          <LegendItem
            key={`item-${index}`}
            onMouseEnter={() => onHover(id)}
            onMouseLeave={() => onHover(null)}
            align={'center'}
            role={'button'}
          >
            <Stack spacing={0.5} direction={'row'} alignItems={'center'}>
              <IconWrapper onClick={() => onToggle(id, !hidden)}>
                <ActionButton
                  size={'small'}
                  fontSize={18}
                  icon={hidden ? <VisibilityIcon /> : <VisibilityOffIcon />}
                />
                <MarkerIcon hidden={hidden} color={color} width={8} height={8}>
                  <circle cx={4} cy={4} r={4} opacity={strokeOpacity} />
                </MarkerIcon>
              </IconWrapper>
              <Title
                size={'10px'}
                hidden={hidden}
                style={{ overflow: 'hidden' }}
                lineClamp={2}
                title={value}
              >
                {value}
              </Title>
              {withMoveToOwnAxis && (
                <IconWrapper>
                  {ownAxis ? (
                    <CrossedActionButton
                      size={'small'}
                      onClick={() => onChangeAxis(id, !ownAxis)}
                      icon={<KeyboardTabIcon />}
                      tooltip={'Data series on its group axis'}
                    />
                  ) : (
                    yAxisGroupCounter[legendPayload.yAxisId] > 1 && (
                      <ActionButton
                        size={'small'}
                        onClick={() => onChangeAxis(id, !ownAxis)}
                        icon={<KeyboardTabIcon />}
                        tooltip={'Data series on its own axis'}
                      />
                    )
                  )}
                </IconWrapper>
              )}
            </Stack>
          </LegendItem>
        );
      })}
    </div>
  );
};

export default LegendContent;
